module.exports = __webpack_public_path__ + "img/light-on.632e59e5.png";